import React, { useState, useEffect, useRef } from 'react';

function Stats() {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({ nodes: 0, events: 0, accuracy: 0 });
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    let step = 0;
    const timer = setInterval(() => {
      step++;
      const progress = step / steps;

      setCounts({
        nodes: Math.floor(2342 * progress),
        events: Math.floor(1441 * progress),
        accuracy: (98.7 * progress).toFixed(1)
      });

      if (step >= steps) {
        clearInterval(timer);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [isVisible]);

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="stats-container">
        <div className="stat-card">
          <div className="stat-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2"/>
              <circle cx="24" cy="16" r="4" fill="currentColor"/>
              <circle cx="16" cy="28" r="4" fill="currentColor"/>
              <circle cx="32" cy="28" r="4" fill="currentColor"/>
            </svg>
          </div>
          <div className="stat-number">{counts.nodes.toLocaleString()}</div>
          <div className="stat-description">Active Intelligent Nodes</div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <path d="M8 24L20 12L28 20L40 8" stroke="currentColor" strokeWidth="2" fill="none"/>
              <circle cx="20" cy="12" r="3" fill="currentColor"/>
              <circle cx="28" cy="20" r="3" fill="currentColor"/>
              <circle cx="40" cy="8" r="3" fill="currentColor"/>
            </svg>
          </div>
          <div className="stat-number">{counts.events.toLocaleString()}</div>
          <div className="stat-description">Events Processed Today</div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2"/>
              <path d="M16 24L22 30L34 18" stroke="currentColor" strokeWidth="2" fill="none"/>
            </svg>
          </div>
          <div className="stat-number">{counts.accuracy}%</div>
          <div className="stat-description">Prediction Accuracy</div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <rect x="8" y="32" width="6" height="8" fill="currentColor"/>
              <rect x="18" y="24" width="6" height="16" fill="currentColor"/>
              <rect x="28" y="16" width="6" height="24" fill="currentColor"/>
              <rect x="38" y="12" width="6" height="28" fill="currentColor"/>
            </svg>
          </div>
          <div className="stat-number">24/7</div>
          <div className="stat-description">Real-time Monitoring</div>
        </div>
      </div>
    </section>
  );
}

export default Stats;

